import React from "react";
import { Box, Tooltip } from "@chakra-ui/react";
import { PRIORITY_META } from "../../utils/taskPriority";

// A task's or order's priority as a letter badge (red H, yellow M, grey L)
// whose hover says what it means; nothing for an item without one.
export default function PriorityIcon({ priority }) {
  const meta = PRIORITY_META[priority];
  if (!meta) return null;
  return (
    <Tooltip label={meta.hint} hasArrow openDelay={150}>
      <Box as="span" role="img" aria-label={`${meta.label} priority`} tabIndex={0}
           data-testid={`priority-${priority}`}
           display="inline-flex" alignItems="center" justifyContent="center" flexShrink={0}
           w="20px" h="20px" borderRadius="sm" bg={meta.bg} color={meta.fg}
           fontSize="xs" fontWeight="bold" lineHeight={1} cursor="help">
        {meta.glyph}
      </Box>
    </Tooltip>
  );
}
